import { InputFieldType } from "../Components/Form/Form"
import { PHONE_COMPLETE_REGEX, PHONE_DIGITS } from "@eip/shared/utils/phone"

const required = {
  value: true,
  message: "Required Field",
  frMessage: "Champ obligatoire",
}

export const basic_text_validator = {
  required,
  fieldType: "text" as InputFieldType,
}

export const basic_number_validator = {
  required,
  fieldType: "number" as InputFieldType,
  pattern: {
    value: /^\d+(\.\d+)?$/,
    message: "Please enter only numerical characters",
    frMessage: "Veuillez entrer uniquement des caractères numériques"
  }
}

export const hst_number_validator = {
  required: {
    value: true,
    message: "GST/HST number is required",
    frMessage: "Le numéro de TPS/TVH est obligatoire",
  },
  fieldType: "text" as InputFieldType,
  pattern: {
    value: /^\d{9}RT\d{4}$/,
    message: "Must be 15 characters: 9 digits + RT + 4 digits (e.g., 123456789RT0001)",
    frMessage: "Doit comporter 15 caractères : 9 chiffres + RT + 4 chiffres (p. ex. 123456789RT0001)"
  }
}

export const pst_number_validator = {
  required: {
    value: true,
    message: "PST/RST number is required",
    frMessage: "Le numéro de TVP/TVD est obligatoire",
  },
  fieldType: "text" as InputFieldType,
  pattern: {
    value: /^\d{6}-?\d$/,
    message: "PST/RST number must be 7 digits (format: xxxxxx-x)",
    frMessage: "Le numéro de TVP/TVD doit comporter 7 chiffres (format : xxxxxx-x)"
  }
}

export const business_number_validator = {
  required: {
    value: true,
    message: "Business Number is required",
    frMessage: "Le numéro d'entreprise est obligatoire"
  },
  fieldType: "text" as InputFieldType,
  pattern: {
    value: /^\d{9}$/,
    message: "Business Number must be exactly 9 digits",
    frMessage: "Le numéro d'entreprise doit comporter exactement 9 chiffres"
  }
}

export const dash_number_validator = {
  required,
  fieldType: "number" as InputFieldType,
}

export const company_name_validator = {
  required: {
    value: true,
    message: "Required Field",
    frMessage: "Champ obligatoire",
  },
  minLength: {
    value: 3,
    message: "Minimum 3 characters",
    frMessage: "Minimum 3 caractères",
  },
  maxLength: {
    value: 50,
    message: "Maximum 50 characters",
    frMessage: "Maximum 50 caractères",
  }
}

export const email_validator = {
  fieldType: "email" as InputFieldType,
  required,
  pattern: {
    value: /^[\w\-\.\+]+@([\w-]+\.)+[\w-]{2,6}$/,
    message: "Please enter a valid email",
    frMessage: "Veuillez entrer une adresse courriel valide"
  }
}

export const unique_email_validator = {
  fieldType: "uniqueEmail" as InputFieldType,
  required,
  pattern: {
    value: /^[\w\-\.\+]+@([\w-]+\.)+[\w-]{2,6}$/,
    message: "Please enter a valid email",
    frMessage: "Veuillez entrer une adresse courriel valide"
  }
}

export const phone_validator = {
  fieldType: "tel" as InputFieldType,
  required,
  pattern: {
    value: PHONE_COMPLETE_REGEX,
    message: `Please enter a valid ${PHONE_DIGITS} digits phone number (numbers only)`,
    frMessage: `Veuillez entrer un numéro de téléphone valide de ${PHONE_DIGITS} chiffres (chiffres seulement)`
  }
}

export const url_validator = {
  fieldType: "url" as InputFieldType,
  required,
  pattern: {
    value: /^(https?:\/\/)?(www\.)?[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\.[a-zA-Z]{2,})+([/\w\-._~:/?#[\]@!$&'()*+,;=%]*)?$/,
    message: "Please provide a valid URL (e.g., https://www.example.com)",
    frMessage: "Veuillez fournir une URL valide (p. ex. https://www.example.com)"
  }
}

export const postal_code_validator = {
  required,
  fieldType: "text" as InputFieldType,
  pattern: {
    value: /^[A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d$/,
    message: "Please enter a valid Canadian postal code (e.g., A1A 1A1)",
    frMessage: "Veuillez entrer un code postal canadien valide (p. ex. A1A 1A1)"
  }
}

export const date_validator = {
  required
}

// Login password validator (no strength requirements - allows old weak passwords)
export const login_password_validator = {
  fieldType: "password" as InputFieldType,
  required: {
    value: true,
    message: "Required Field",
    frMessage: "Champ obligatoire",
  },
  maxLength: {
    value: 100,
    message: "Maximum 100 characters",
    frMessage: "Maximum 100 caractères",
  }
}

// Strong password validator (for registration and password change)
export const password_validator = {
  fieldType: "password" as InputFieldType,
  required: {
    value: true,
    message: "Required Field",
    frMessage: "Champ obligatoire",
  },
  minLength: {
    value: 12,
    message: "Password must be at least 12 characters",
    frMessage: "Le mot de passe doit comporter au moins 12 caractères",
  },
  maxLength: {
    value: 100,
    message: "Maximum 100 characters",
    frMessage: "Maximum 100 caractères",
  },
  pattern: {
    value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{12,}$/,
    message: "Password must contain uppercase, lowercase, number, and special character",
    frMessage: "Le mot de passe doit contenir une majuscule, une minuscule, un chiffre et un caractère spécial"
  }
}

export const cpassword_validator = {
  fieldType: "password" as InputFieldType,
  required: {
    value: true,
    message: "Required Field",
    frMessage: "Champ obligatoire",
  },
  minLength: {
    value: 12,
    message: "Password must be at least 12 characters",
    frMessage: "Le mot de passe doit comporter au moins 12 caractères",
  },
  maxLength: {
    value: 100,
    message: "Maximum 100 characters",
    frMessage: "Maximum 100 caractères",
  },
  pattern: {
    value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{12,}$/,
    message: "Password must contain uppercase, lowercase, number, and special character",
    frMessage: "Le mot de passe doit contenir une majuscule, une minuscule, un chiffre et un caractère spécial"
  }
}

export const boolean_selection_validator = {
  returnValueType: "boolean",
  required: {
    value: true,
    message: "Please select an option",
    frMessage: "Veuillez sélectionner une option"
  }
}

export const selection_validator = {
  required: {
    value: true,
    message: "Please select an option",
    frMessage: "Veuillez sélectionner une option"
  }
}

export const multiselect_validator = {
  required
}

export const description_validator = {
  required,
  fieldType: "text" as InputFieldType,
  minLength: {
    value: 50,
    message: "Description must be at least 50 characters",
    frMessage: "La description doit comporter au moins 50 caractères",
  },
  maxLength: {
    value: 2000,
    message: "Description cannot exceed 2000 characters",
    frMessage: "La description ne peut pas dépasser 2000 caractères",
  },
}

export const firm_name_validator = {
  required,
  fieldType: "text" as InputFieldType,
  minLength: {
    value: 2,
    message: "Firm name must be at least 2 characters",
    frMessage: "Le nom de la firme doit comporter au moins 2 caractères",
  },
  maxLength: {
    value: 100,
    message: "Firm name cannot exceed 100 characters",
    frMessage: "Le nom de la firme ne peut pas dépasser 100 caractères",
  },
}

export const address_validator = {
  returnValueType: "boolean",
  required: {
    value: true,
    message: "Please provide an address",
    frMessage: "Veuillez fournir une adresse"
  }
}
